import React, { useState } from 'react'
import { api } from '../../utils/api'

// Audio Trader brand yellow - matches the storefront magazine "Our pick" badge.
const AT_YELLOW = '#FFD44D'
const AT_INK = '#242A27'

/**
 * STAFF PICK button - flags a Shopify product as a storefront staff pick.
 * Additive: marks the product at status 'draft' (never auto-goes-live).
 * Used in Inventory and Receiving row actions.
 *
 * priceCents should already be in pence; pass null if unknown.
 */
function StaffPickButton({ productId, title, handle, priceCents = null, imageUrl, size = 'sm' }) {
  const [state, setState] = useState('idle')

  async function mark(e) {
    if (e && e.stopPropagation) e.stopPropagation()
    if (state === 'saving' || state === 'done') return
    setState('saving')
    try {
      await api.post('/api/marketing/staff-picks', {
        shopify_product_id: String(productId),
        product_title: title || null,
        product_handle: handle || null,
        price_cents: priceCents,
        image_url: imageUrl || null
      })
      setState('done')
    } catch (error) {
      console.error('Failed to mark staff pick:', error)
      setState('error')
    }
  }

  const label = {
    idle: 'Staff Pick', saving: 'Saving...', done: 'Staff Pick added', error: 'Retry'
  }[state]

  return (
    <button
      type="button"
      onClick={mark}
      disabled={!productId || state === 'saving'}
      title="Mark as a storefront Staff Pick (saved as Draft - does not go live automatically)"
      className={`btn btn-${size}`}
      style={{ background: AT_YELLOW, color: AT_INK, border: 'none', fontWeight: 600, whiteSpace: 'nowrap', opacity: state === 'done' ? 0.65 : 1 }}
    >
      <span aria-hidden="true" style={{ marginRight: 4 }}>✦</span>{label}
    </button>
  )
}

export default StaffPickButton
